import {EnvironmentName, getEnvironmentNameFromHostname, getStampedEnv} from "@buildwithflux/shared";

const PRODUCTION_ASSET_PIPELINE_URL = "https://assetpipeline.flux.ai";
const STAGING_ASSET_PIPELINE_URL = "https://assetpipeline-staging.flux.ai";
const PREVIEW_APPLICATION_ENV = /^(pr|preview)-\d+$/i;

function isPreviewEnvironment(): boolean {
    const applicationEnv = getStampedEnv()?.appEnv ?? process.env.APPLICATION_ENV;
    if (applicationEnv !== undefined) {
        return PREVIEW_APPLICATION_ENV.test(applicationEnv);
    }

    // Web workers have no window or proxy stamp, but they do have location.
    const hostname = globalThis.location?.hostname;
    return hostname !== undefined && getEnvironmentNameFromHostname(hostname) === EnvironmentName.Preview;
}

export function getAssetPipelineCdnBaseUrl(): string {
    if (process.env.REACT_APP_AWS_S3_3D_CDN_CLOUDFRONT_URL) {
        return process.env.REACT_APP_AWS_S3_3D_CDN_CLOUDFRONT_URL;
    }
    return isPreviewEnvironment() ? STAGING_ASSET_PIPELINE_URL : PRODUCTION_ASSET_PIPELINE_URL;
}

export function getAssetPipelineApiBaseUrl(): string {
    if (process.env.REACT_APP_AWS_S3_3D_CDN_CLOUDFRONT_URL) {
        return process.env.REACT_APP_AWS_S3_3D_CDN_CLOUDFRONT_URL;
    }
    return isPreviewEnvironment() ? STAGING_ASSET_PIPELINE_URL : PRODUCTION_ASSET_PIPELINE_URL;
}

function getAssetPipelineBaseUrls(): string[] {
    return [PRODUCTION_ASSET_PIPELINE_URL, STAGING_ASSET_PIPELINE_URL, getAssetPipelineCdnBaseUrl()];
}

export function isAssetPipelineUrl(value: string): boolean {
    try {
        const url = new URL(value);
        return getAssetPipelineBaseUrls().some((baseUrl) => {
            const base = new URL(baseUrl);
            const basePath = base.pathname.replace(/\/+$/, "");
            const isOnBasePath =
                basePath.length === 0 || url.pathname === basePath || url.pathname.startsWith(`${basePath}/`);
            return url.origin === base.origin && isOnBasePath;
        });
    } catch {
        return false;
    }
}

export function isAssetPipelinePreviewUrl(value: string): boolean {
    if (!isAssetPipelineUrl(value)) return false;
    try {
        const url = new URL(value);
        const queryIndex = value.indexOf("?");
        const fragmentIndex = value.indexOf("#");
        return (
            queryIndex >= 0 &&
            (fragmentIndex < 0 || queryIndex < fragmentIndex) &&
            getAssetPipelineBaseUrls().some((baseUrl) => {
                const base = new URL(baseUrl);
                const basePath = base.pathname.replace(/\/+$/, "");
                return url.origin === base.origin && url.pathname === `${basePath}/`;
            })
        );
    } catch {
        return false;
    }
}
